import { createApp } from "vue";
import App from "./App.vue";

const app = createApp(App);
//引入交互
import axios from "axios";
//引入配置
import config from "../config/index.js";

//引入ViewUI
import ViewUIPlus from "view-ui-plus";
import "view-ui-plus/dist/styles/viewuiplus.css";

//全局提示插件
import MessageUtils from "./utils/MessageUtils.js";
import NoticeUtils from "./utils/NoticeUtils.js";
import DateUtil from "./utils/DateUtil.js";

import store from "./store";
import "vditor/src/assets/less/index.less";
import {
  checkUserInfo,
  getUserInfo,
  removeUserInfo,
} from "@/utils/LocalStoreUtil";
import router from "./router/index.js";

app.config.globalProperties.config = config;
app.config.globalProperties.$state = store;

//为axios起一个别名
app.config.globalProperties.$http = axios;
app.use(router);
app.use(ViewUIPlus);
app.use(MessageUtils);
app.use(NoticeUtils);
app.use(store);
app.use(DateUtil);
app.mount("#app");

const AUTH_WHITE_LIST = ["/login"];
router.beforeEach(function (to, from, next) {
  const userInfo = getUserInfo();
  if (!userInfo.sysUsers) {
    if (AUTH_WHITE_LIST.indexOf(to.path) > -1) {
      next();
    } else {
      next({
        path: "/login",
      });
    }
  } else {
    if (!checkUserInfo()) {
      ViewUIPlus.Message.error("登录超时，请重新登录");
      next({ path: "/login" });
    } else {
      to.path === "/login" ? next({ path: "/home/center" }) : next();
    }
  }
});

// 添加响应拦截器
axios.interceptors.response.use(
  (data) => {
    ///axiox 异常过滤点
    if (data.data.code === -10) {
      ViewUIPlus.Message.error(data.data.message);
      return;
    } else if (data.data.code === -3) {
      removeUserInfo();
      router.push("/login");
      return;
    } else if (data.data.code === -9) {
      ViewUIPlus.Message.error(data.data.message);
      return;
    }
    return data;
  },
  (error) => {
    // 处理响应错误
    console.log(error);
    return Promise.reject(error);
  }
);
